import { render, staticRenderFns } from "./SetPricePopup.vue?vue&type=template&id=581ff71d&scoped=true&"
import script from "./SetPricePopup.vue?vue&type=script&lang=js&"
export * from "./SetPricePopup.vue?vue&type=script&lang=js&"
import style0 from "./SetPricePopup.vue?vue&type=style&index=0&id=581ff71d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581ff71d",
  null
  
)

export default component.exports